/** The old shared details URL reads exactly the registered visit's fields. */
import { useLocation } from "react-router";
import { Bento, PageRefusal } from "@/components/ui/box";
import { useCourseDetailsVisit } from "./course-details-visit";
import { registrarCourseCopy as words } from "./registrar-course-copy";

export function CourseDetailsEditor({ courseId }: { courseId: string }) {
  const location = useLocation();
  const query = new URLSearchParams(location.search); query.delete("edit");
  const back = `${location.pathname}${query.size ? `?${query}` : ""}${location.hash}`;
  const resolution = useCourseDetailsVisit({ object: "course", id: courseId, job: "details" });
  if (!resolution || resolution.status === "loading") return <p role="status">{words.reading}</p>;
  if (resolution.status === "refused") return <PageRefusal id="course-details" journey="course-details" refusal={{ reason: "forbidden", sentence: words.detailsRefused, back: { label: words.courseSettings, to: back } }} />;
  return <Bento id={`course-details-${courseId}`} journey="course-details" boxes={resolution.boxes.map(box => ({ ...box, exits: [{ label: words.courseSettings, to: back }] }))} />;
}
